import React, { Component } from 'react'

class SvgFile extends Component {
  render() {
    const { width, height, fillColor, className } = this.props
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13 8"
      >
        <path
          fill={fillColor}
          fillRule="evenodd"
          d="M5.876 4.191c.345.361.903.361 1.248 0l3.745-3.92a.856.856 0 0 1 1.249 0l.624.653a.957.957 0 0 1 0 1.307L7.748 7.459a1.71 1.71 0 0 1-2.496 0L.258 2.23a.957.957 0 0 1 0-1.307L.882.27a.856.856 0 0 1 1.249 0l3.745 3.92z"
        />
      </svg>
    )
  }
}

SvgFile.defaultProps = {
  width: 13,
  height: 8,
  fillColor: '#ffffff'
}

export default SvgFile
